import { ArrowDown } from "lucide-react";

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.querySelector("#about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_relaxed-margulis-6/artifacts/vsru255a_IMG_2552.jpeg"
          alt="Brittany Bailey Photography"
          className="w-full h-full object-cover" style={{ objectPosition: "center 40%" }}
        />
        {/* Left gradient for text legibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#FDFBF9]/90 via-[#FDFBF9]/60 to-transparent" />
      </div>

      {/* Content - Left aligned */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full pt-20">
        <div className="max-w-lg">
          <p className="overline text-[#5C5A56] mb-6 animate-fade-in">
            Award-Winning Photography
          </p>
          
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-[#2C2A28] leading-tight mb-8 animate-fade-in-up">
            Let's create something
            <br />
            <span className="italic">magical</span> together
          </h1>
          
          <p className="font-body text-lg text-[#5C5A56] max-w-md mb-10 animate-fade-in-up animation-delay-200">
            Capturing real moments, natural vibes, and making every session feel fun instead of stressful.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4 animate-fade-in-up animation-delay-300">
            <a
              href="#booking"
              className="px-8 py-4 bg-[#2C2A28] text-[#FDFBF9] font-body text-sm tracking-wide hover:bg-[#5C5A56] transition-all duration-300"
              data-testid="hero-book-button"
            >
              Book Your Session
            </a>
            <a
              href="#portfolio"
              className="px-8 py-4 border border-[#2C2A28] text-[#2C2A28] font-body text-sm tracking-wide hover:bg-[#2C2A28] hover:text-[#FDFBF9] transition-all duration-300"
              data-testid="hero-portfolio-button"
            >
              View Portfolio
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-[#2C2A28] animate-bounce"
        data-testid="scroll-indicator"
      >
        <ArrowDown size={28} strokeWidth={1.5} />
      </button>
    </section>
  );
};

export default HeroSection;
